import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

import Header from "./components/Header";
import ContactDirect from "./components/ContactDirect";
import CarouselCards from "./components/CarouselCards";
import CommentCarousel from "./components/CommentCarousel";
import AboutSection from "./components/AboutSection";
import Services from "./components/Services";
import CTAJobs from "./components/CTAJobs";
import ContactFAQ from "./components/ContactFAQ";
import Footer from "./components/Footer";
import "./LandingPage.css";

const LandingPage = () => {
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [hideBanner, setHideBanner] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookieConsent");
    if (!consent) {
      setShowCookieBanner(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    Cookies.set("cookieConsent", "true", { expires: 365 });
    closeBanner();
  };

  const handleRejectCookies = () => {
    Cookies.set("cookieConsent", "false", { expires: 365 });
    closeBanner();
  };

  const closeBanner = () => {
    setHideBanner(true);
    setTimeout(() => setShowCookieBanner(false), 500); // attende animazione slide-out
  };

  return (
    <div className="font-sans text-gray-800">
      <Header />
      <ContactDirect />
      <CommentCarousel />
      <AboutSection />
      <CarouselCards />
      <Services />
      <CTAJobs />
      <ContactFAQ />
      <Footer />

      {showCookieBanner && (
        <div
          className={`cookie-banner ${hideBanner ? "hide" : ""}`}
          role="dialog"
          aria-live="polite"
        >
          <div className="cookie-content">
            <p>
              <strong>No tracking, just basics.</strong> This site uses strictly necessary technical cookies to ensure a smooth browsing experience and to remember your preferences regarding this banner. We do not track you. <a href="/privacy-policy" className="cookie-link">Learn more</a>.
            </p>
          </div>
          <div className="cookie-actions">
            <button
              type="button"
              className="cookie-btn cookie-btn-secondary"
              onClick={handleRejectCookies}
            >
              Decline
            </button>
            <button
              type="button"
              className="cookie-btn cookie-btn-primary"
              onClick={handleAcceptCookies}
            >
              Got it!
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage;